import { render } from "./Backend.vue?vue&type=template&id=5cb5501b&scoped=true"
import script from "./Backend.vue?vue&type=script&lang=js"
export * from "./Backend.vue?vue&type=script&lang=js"

import "./Backend.vue?vue&type=style&index=0&id=5cb5501b&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Tenisu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb5501b"]])

export default __exports__